import React from "react";
import { ApiSubtask, ApiTask } from "src/api/types";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Loader from "src/components/Loader";
import SubtaskCard from "src/components/tasks/SubtaskCard";
import useGet from "src/hooks/rest/useGet";

interface SubtasksGridProps extends Translation {
	task: ApiTask;
}

const SubtasksGrid = ({ task, t }: SubtasksGridProps) => {
	const [{ data }, loading] = useGet(`/company/tasks/${task.hid}/subtasks`);

	if (!loading && data.length === 0) {
		return (
			<div className="flex justify-center items-center flex-col">
				<strong>{t("empty.title")}</strong>
				<p>{t("empty.text")}</p>
			</div>
		);
	}

	if (loading) {
		return (
			<div className="flex flex-1 justify-center items-center flex-col">
				<Loader />
			</div>
		);
	}

	return (
		<div className="flex flex-wrap items-start gap-4">
			{(data || []).map((item: ApiSubtask) => (
				<SubtaskCard key={`subtask-${item.hid}`} task={item} />
			))}
		</div>
	);
};

SubtasksGrid.locale = {
	nl: {
		empty: {
			title: "Geen opdrachten gevonden",
			text: "Deze opdracht heeft geen onderliggende opdrachten",
		},
	},
	en: {
		empty: {
			title: "No subtasks found",
			text: "This task does not have any subtasks",
		},
	},
};

export default withTranslation(SubtasksGrid);
